import {Link} from "react-router-dom";

//CSS
import styles from "./excursionsGroup.module.less";

export default function ExcursionsGroup ({groups, language, zone}) {

  let groupsHTML = "No hay grupos de excursiones";

  if(Array.isArray(groups) && groups.length > 0){
    groupsHTML = groups.map((group,index)=>{
      return (
        <div key={index} className={styles.group}>
          <Link  to={'/' + language + "/search/"  + zone + '/' + group.webslug}>
            <img className={styles.thumbnail} src={group.thumbnail} alt={"thumbnail " + group.name} />
            <img className={styles.movilthumbnail} src={group.movilthumbnail} alt={"movil thumbnail " + group.name} />
            <div className={styles.sheet}>
              <div className={styles.background}></div>
              <div className={styles.contentExcursion}>
                <div className={styles.name}>{group.name}</div>
              </div>
            </div>
          </Link>
        </div>
      );
    });
  }

  return (
    <div className={styles.groups}>
      {groupsHTML}
    </div>
  );

}
